import _ from 'underscore';
import Backbone from 'backbone';
import UserPreference from 'models/user/UserPreference';
import SurveyBanner from 'models/user/SurveyBanner';
import Loadable from 'utils/extensions/Loadable';
import LocationUtil from 'utils/LocationUtil';
import templateHtml from 'templates/main/BetaTestersSurveyBanner.html';

var LoadableView = Backbone.View.extend(Loadable);

var BetaTestersSurveyBanner = LoadableView.extend({
    template: _.template(templateHtml),

    events: {
        'click .js-close-survey-banner': 'closeSurvey',
        'click a.survey-link': 'closeSurvey'
    },

    initialize: function() {
        this.surveyBanner = new SurveyBanner();
    },

    provideDependencies: function(modelSynchronizer) {
        modelSynchronizer.addModel({
            model: this.surveyBanner,
            required: true
        });
    },

    onDependenciesLoaded: function() {
        if (!this.surveyBanner.isAvailable()) {
            return;
        }

        LocationUtil.isInternal((isInternal) => {
            if (!isInternal) {
                hasUserCompletedSurvey({
                    completed: this.displayBanner.bind(this)
                });
            }
        });

        var that = this;
        function hasUserCompletedSurvey(callback) {
            if (!callback) {
                throw 'Callback is required';
            }

            that.userCompletedSurvey = new UserPreference({
                key: that.surveyBanner.getSurveyData().key
            });

            // Whether the user interacted (completed/dismissed) with the survey or not
            that.userCompletedSurvey.fetch({
                success: function(model) {
                    callback.completed(model.get('value') === 'true');
                }
            });
        }
    },

    displayBanner: function(isCompleted) {
        if (isCompleted) {
            return;
        }
        this.render();
    },

    render: function() {
        this.$el.html(
            this.template({
                survey: this.surveyBanner.getSurveyData()
            })
        );

        $('body').addClass('show-takeover');
    },

    closeSurvey: function() {
        this.userCompletedSurvey.set('value', 'true');
        this.userCompletedSurvey.save();

        this.$el.html('');

        $('body').removeClass('show-takeover');
    }
});

export default BetaTestersSurveyBanner;
